import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { CrystalVisual } from "@/components/CrystalVisual";
import { Screen, TopBar, Loader } from "@/components/ui";
import { useAuth } from "@/context/AuthContext";
import { crystalsApi } from "@/data/api";

export default function Favourites() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    crystalsApi.favourites(token).then((r) => setItems(r.items || [])).catch(() => setItems([])).finally(() => setLoading(false));
  }, [token]);

  return (
    <Screen>
      <TopBar title="My Crystals ✨" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 40px" }}>
        {loading ? (
          <Loader />
        ) : items.length === 0 ? (
          <div style={{ padding: "60px 20px", textAlign: "center" }}>
            <Icon name="heart" size={40} color={colors.brandSecondary} />
            <div style={{ color: colors.onSurface, fontSize: 17, fontWeight: 700, marginTop: 14, fontFamily: fonts.text }}>No saved crystals yet</div>
            <div style={{ color: colors.muted, fontSize: 14, marginTop: 6, lineHeight: "20px", fontFamily: fonts.text }}>Tap the heart on any crystal to save it here for quick access 🖤</div>
            <button className="pressable" onClick={() => navigate("/crystal-school/library")} style={{ display: "inline-flex", alignItems: "center", gap: 8, background: colors.brand, color: colors.onBrand, border: "none", borderRadius: 14, padding: "12px 20px", marginTop: 18, cursor: "pointer", fontSize: 14, fontWeight: 700, fontFamily: fonts.text }}>
              <Icon name="search" size={16} color={colors.onBrand} />Explore the library
            </button>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
            {items.map((c) => (
              <button key={c.id} data-testid={`fav-card-${c.slug}`} className="pressable" onClick={() => navigate(`/crystal/${c.slug}`)} style={{ border: "none", background: "none", padding: 0, cursor: "pointer" }}>
                <CrystalVisual name={c.name} imageUrl={c.image_url} seed={c.visual_seed} height={130} />
              </button>
            ))}
          </div>
        )}
      </div>
    </Screen>
  );
}
